import BackgroundCheckDisputeAlert from './BackgroundCheckDisputeAlert';
export default BackgroundCheckDisputeAlert;
